import { Fragment, useEffect, useState } from 'react';

import { VENUES_TAXONOMY_KEY } from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';

import {
  WeddingLocationInput,
  isAnswered as doesInputHaveValues,
} from '~/components/common/form/WeddingLocationInput/WeddingLocationInput';
import { CouplesStorefrontDetails } from '~/types/storefrontDetails';

import { useInquiryValues } from '../../context/InquiryContext';
import { LoadedInquiryValues } from '../../context/types';
import { InquiryFormValues } from '../../types';

import styles from './weddingLocationField.module.less';

export const FIELD_NAMES: (keyof InquiryFormValues)[] = ['weddingLocation'];

export const isAnswered = ({ initialValues }: { initialValues: InquiryFormValues }): boolean => {
  return doesInputHaveValues(initialValues);
};

export const allowLocation = (storefront: Pick<CouplesStorefrontDetails, 'taxonomyKey'>) => {
  return storefront.taxonomyKey !== VENUES_TAXONOMY_KEY;
};

export const WeddingLocationField = ({ showLabel = true }: { showLabel?: boolean }) => {
  const { storefront } = useInquiryValues() as LoadedInquiryValues;

  const [askLocation, setAskLocation] = useState(false);

  useEffect(() => {
    setAskLocation(allowLocation(storefront));
  }, [storefront]);

  if (askLocation) {
    return (
      <fieldset className={styles.weddingLocationField}>
        {showLabel && <legend>Wedding location</legend>}
        <WeddingLocationInput<InquiryFormValues> />
      </fieldset>
    );
  }

  return <Fragment />;
};

const WeddingLocationFieldModule = {
  isAnswered,
  FIELD_NAMES,
};

export default WeddingLocationFieldModule;
